var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6ZM15.9996 10.6001C13.0173 10.6001 10.5996 13.0178 10.5996 16.0001C10.5996 18.9824 13.0173 21.4001 15.9996 21.4001C18.9819 21.4001 21.3996 18.9824 21.3996 16.0001C21.3996 13.0178 18.9819 10.6001 15.9996 10.6001ZM8.59961 16.0001C8.59961 11.9132 11.9127 8.6001 15.9996 8.6001C20.0865 8.6001 23.3996 11.9132 23.3996 16.0001C23.3996 20.087 20.0865 23.4001 15.9996 23.4001C11.9127 23.4001 8.59961 20.087 8.59961 16.0001ZM26.4008 6.39995C27.2844 6.39995 28.0008 5.68361 28.0008 4.79995C28.0008 3.9163 27.2844 3.19995 26.4008 3.19995C25.5171 3.19995 24.8008 3.9163 24.8008 4.79995C24.8008 5.68361 25.5171 6.39995 26.4008 6.39995Z",
    fill: "#56769A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.addc15be9b02aeaaae5867b1a827e2b2.svg";
export { ForwardRef as ReactComponent };